import React from 'react'

export default function Footer() {
  return (
    <div>
        <h4>&copy; Top Album</h4>
    </div>
  )
}